<template>
  <b-modal
    ref="setReportDemandDialog"
    centered
    title="Zgłaszanie popytu"
    :visible="reportDemandPopupVisible"
    @hidden="hide"
  >
    <template #modal-header="{ close }">
      <h5 class="v-step-0">Zgłaszanie popytu</h5>
      <!-- <button class="cursor-pointer v-step-12" v-on:click="startTour()">
                      <span class="oi oi-question-mark" title="Asystent" aria-hidden="true"></span>
                      <span class="sr-only">Asystenet</span>
                    </button> -->

      <b-row class="pr-3 gap-3"
        ><b-button
          v-if="isMobileDevice"
          class="question-button"
          :variant="contextAssistantActive ? 'warning' : 'secondary'"
          @click="toggleAssistant"
        >
          <span
            :variant="'warning'"
            class="oi oi-question-mark"
            title="Asystent"
            aria-hidden="true"
          ></span>
          <span class="sr-only">Asystenet</span>
        </b-button>
        <button @click="hide" class="close">
          <span aria-hidden="true">&times;</span>
        </button></b-row
      >

      <!-- <i class="bi bi-question-circle"></i> -->
    </template>
    <b-form>
      {{ reportDemandPopupAddress }}
    </b-form>
    <div slot="modal-footer">
      <b-btn
        variant="primary"
        class="mt-2 btn-block"
        v-if="isAddressExists"
        @click="reportDemand"
        >Zgłoś adres i popyt</b-btn
      >
      <b-btn
        variant="primary"
        class="mt-2 btn-block"
        @click="reportDemandOnClickCoordinates"
        >Zgłoś adres i popyt w miejscu kliknięcia</b-btn
      >
    </div>
  </b-modal>
</template>

<script>
import {
  REPORT_DEMAND_POPUP_HIDE,
  WINDOW_DEMAND_FORM_SHOW,
  TOGGLE_CONTEXT_ASSISTANT
} from '../store/mutations.type';
import { DISPLAY_CONTEXT_ASSISTANT_MESSAGE } from '../store/actions.type';
import { mapGetters } from 'vuex';

export default {
  name: 'ReportDemandDialog',
  data: function() {
    return {};
  },
  computed: {
    ...mapGetters([
      'reportDemandPopupVisible',
      'reportDemandAddress',
      'isMobileDevice',
      'contextAssistantActive'
    ]),
    reportDemandPopupAddress() {
      const address = this.$store.getters.reportDemandAddress;
      if (address && address.street && address.city && address.number) {
        return address.street + ' ' + address.number + ', ' + address.city;
      } else {
        return '';
      }
    },
    isAddressExists() {
      return (
        this.$store.getters.reportDemandAddress !== null &&
        this.$store.getters.reportDemandAddress.id !== null
      );
    }
  },
  methods: {
    reportDemand() {
      if (this.contextAssistantActive) {
        this.$store.dispatch(DISPLAY_CONTEXT_ASSISTANT_MESSAGE, {
          message: 'Przycisk ten otwiera formularz zgłaszania adresu i popytu.'
        });
      } else {
        this.$store.commit(
          WINDOW_DEMAND_FORM_SHOW,
          this.$store.getters.reportDemandAddress
        );
        this.hide();
      }
    },
    reportDemandOnClickCoordinates() {
      if (this.contextAssistantActive) {
        this.$store.dispatch(DISPLAY_CONTEXT_ASSISTANT_MESSAGE, {
          message:
            'Przycisk ten otwiera formularz zgłaszania adresu i popytu w miejscu kliknięcia.'
        });
      } else {
        this.$store.commit(
          WINDOW_DEMAND_FORM_SHOW,
          this.$store.getters.reportDemandAddress
        );
        this.hide();
      }
    },
    hide() {
      this.$store.commit(REPORT_DEMAND_POPUP_HIDE);
    },
    toggleAssistant() {
      this.$store.commit(TOGGLE_CONTEXT_ASSISTANT);
    }
  }
};
</script>
<style>
.modal-footer > div {
  width: 100%;
}
</style>
